<div class="nha-app-left-nav" [ngClass]="env" *ifDesktop></div>
<nha-maintenance-notification></nha-maintenance-notification>

<div class="nha-app-header-area dark-theme" [ngClass]="env" id="nha-app-header">
	<div class="application-name" *ifDesktop>
		<h1>
			@if (currentApplicationName$ | async; as currentApplicationName) {
				<a [routerLink]="baseRoute" nhaTest="module-name" [innerHTML]="currentApplicationName"></a>
			}
		</h1>
	</div>

	<div class="application-components-area">
		<ng-content select="[breadcrumb]"></ng-content>
		<ng-container #applicationComponent></ng-container>
	</div>

	<div class="application-menu-area">
		@if (showHeaderToken) {
			<mat-chip-option disabled class="environment-chip">
				<span class="label">{{ environmentName }}</span>
			</mat-chip-option>
		}
		<ng-content select="[applicationMenu]"></ng-content>
		<ng-container #applicationMenuComponent></ng-container>
		<div class="utilities">
			@if (showNotificationMenu) {
				<nha-notification-menu [businessSystemID]="notificationBusinessSystemID"></nha-notification-menu>
			}
			<nha-app-launcher></nha-app-launcher>
			<nha-user-profile-menu></nha-user-profile-menu>
		</div>
	</div>
</div>

<div class="nha-app-content-area-wrapper" [ngClass]="env">
	<div class="nha-app-content-area">
		<ng-content></ng-content>
	</div>
</div>
